<template>
  <div>
    <PlanSelection
      @plan-select="onPlanSelect"
    />

    <AddonSelection
      v-model="showAddonSelect"
      :plan="subscriptionCart.selectedPlan"
      :billing-cycle="subscriptionCart.selectedBillingCycle"
      @continue="onAddonConfirm"
    />
    <SinoaSelection
      v-if="showSinoaSelection"
      :basic-user="true"
      @sinoa-select="onSinoaSelect"
      @close="showSinoaSelection = false"
    />
  </div>
</template>

<script>
import PlanSelection from './PlanSelection.vue';
import AddonSelection from './AddonSelection.vue';
import { mapMutations, mapState, mapGetters } from 'vuex';
import { COLORS } from '@/helpers/colors';
import SinoaSelection from '../../pages/chatbot/SinoaSelection.vue';

export default {
  name: 'PaywallForBasicUsers',

  components: {
    PlanSelection,
    AddonSelection,
    SinoaSelection,
  },

  data() {
    return {
      showAddonSelect: false,
      showSinoaSelection: false,
      COLORS,
    };
  },

  computed: {
    ...mapState('chatbot', ['subscriptionCart']),
    ...mapGetters('subscription', ['isCanadian']),
  },

  mounted() {
    this.setSubscriptionCart({ selectedPlanIndex: 1 });
    this.$nextTick(() => this.$emit('scroll-bottom'));
  },

  methods: {
    ...mapMutations('chatbot', ['setSubscriptionCart']),

    onPlanSelect(plan, billingCycle) {
      this.setSubscriptionCart({ selectedPlan: plan, selectedBillingCycle: billingCycle });
      if (this.isCanadian) {
        this.showAddonSelect = false;
        this.showSinoaSelection = true;
      } else {
        this.showAddonSelect = true;
        this.showSinoaSelection = false;
      }
    },

    onAddonConfirm(addons) {
      this.setSubscriptionCart({ selectedAddons: addons });
      this.showAddonSelect = false;
      this.showSinoaSelection = true;
    },

    onSinoaSelect(sinoaId, autoRenew) {
      if (sinoaId) {
        this.setSubscriptionCart({ selectedSinoa: sinoaId, autoRenew });
      }
      this.showSinoaSelection = false;
      this.$emit('checkout');
    },
  },
};
</script>
